module.exports = __webpack_public_path__ + "distribution/img/x1.d3d0d68a.png";